/* eslint-disable require-yield */
import { toast } from "react-toastify";
import { all, put, takeLatest } from "redux-saga/effects";
import { getPoiTypeLayerDataFn } from "../../apis/GeoDataAPI";
import { GeoData } from "../../constants/action-constants/GeoDataActionConstants";
import poiTypeLayerResponseConverter from "../../utils/PoiTypeLayerResponseConverter";
import { getErrorMessage } from "../../utils/util";

/**
 * @param {*} resPoiLayers => array of multiple string "poiTypeLayers"
 * @param {*} bbox => city bbox
 * @returns the array of all combined poi's points
 */
export function* getAllPoiTypeLayersPoints(resPoiLayers = [], bbox) {
  // all points array
  const allPointsArr = [];

  // getting points
  const responseObject = yield getPoiTypeLayerDataFn(resPoiLayers, bbox);

  // converting response
  const pointArr = yield poiTypeLayerResponseConverter(responseObject);

  // pushing points to all points array
  allPointsArr.push(...pointArr);

  return allPointsArr;
}

// for getting poi type layer data for specific city
export function* getPoiTypeLayerData(action) {
  const { resPoiLayers, bbox } = action.payload;

  try {
    // for multiple PoiTypeLayer Ids
    const allPoiPointsArr = yield getAllPoiTypeLayersPoints(resPoiLayers, bbox);

    yield put({
      type: GeoData.GET_POI_TYPE_LAYER_DATA_SUCCESS,
      payload: { allPoiPointsArr },
    });
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: GeoData.GET_POI_TYPE_LAYER_DATA_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export default function* root() {
  yield all([takeLatest(GeoData.GET_POI_TYPE_LAYER_DATA, getPoiTypeLayerData)]);
}
